import { createStore } from 'vuex'
import basket from './modules/basket'
import session from "@/store/modules/session";

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    basket,
    session
  }
})
